module.exports = __webpack_public_path__ + "public/Icons/unavailableIcon.png?2df79535";